import { Form, Typography } from "antd"
import { type FormInstance } from "antd/es/form/hooks/useForm"

import type { TeamMemberMutationData } from "../../types/types.ts"

const { Title } = Typography

interface TeamMemberFormHeaderProps {
  form: FormInstance<TeamMemberMutationData>
  isEdit?: boolean
}

export function TeamMemberFormHeader({
  form,
  isEdit
}: TeamMemberFormHeaderProps) {
  const isInvite = Form.useWatch("is_invite", { form })

  const title = (() => {
    if (isEdit) return "Edit Team Member"
    return isInvite ? "Invite Team Member" : "Add Team Member"
  })()

  return (
    <Title level={3} style={{ textAlign: "left" }}>
      {title}
    </Title>
  )
}
